import styled from 'styled-components';

/** Flight Settings section (Figma sAJAbctHkDywtXXMoeVFTZ 8734:933). */
export const FlightSettingsStyled = styled.section`
  display: flex;
  flex-direction: column;
  row-gap: 24px;
  background: var(--color-sonata-secondary-White, #FFF);
  border-radius: var(--spacing-8);
  padding: var(--spacing-24);

  .flightSettings {

    &__header {
      display: flex;
      flex-direction: column;
      row-gap: var(--spacing-8);

      &Row {
        align-items: center;
        column-gap: var(--spacing-8);
        display: flex;
      }

      &Title {
        flex: 1;
        font: var(--font-title-400-regular);
        color: var(--color-sonata-primary-800, #162237);
      }

      &Description {
        font: var(--font-body-500-regular);
        color: var(--color-sonata-primary-600, #3D5787);
      }
    }

    &__main {
      display: flex;
      flex-direction: column;
      row-gap: 8px;

      &Error {
        display: flex;
        align-items: center;
        gap: 8px;
        font-family: ${props => props.theme.fontSemiBold};
        font-size: ${props => props.theme.fontSizeXS};
        color: ${props => props.theme.uiColors.boxError};
        margin-bottom: 16px;
      }
    }

    &__list {
      border-radius: var(--spacing-8);
      overflow: hidden;
    }

    &__footer {
      align-items: center;
      display: flex;
      justify-content: space-between;
    }

    /* "TOTAL SET: <first date> to <last date> | <budget>" (Figma 8734:1036) */
    &__summary {
      padding: 0;

      .flightsSummary__titleContainerSubtitle {
        color: var(--color-sonata-primary-600);
        font: var(--font-body-400-bold);
      }

      .flightsSummary__dataContainer {
        color: var(--color-sonata-primary-800);
        font: var(--font-body-400-bold);
        gap: var(--spacing-6);

        &Date {
          color: var(--color-sonata-primary-600);
        }

        &Total {
          color: var(--color-sonata-primary-800);
        }
      }
    }
  }
`;
